import _default from './_default';
import mobilonline from './mobilonline';
import freshbox from './freshbox';

import themeComponent from '../../../hoc/themeComponent';

export default themeComponent({ _default, mobilonline, freshbox });
